import axios from "axios";

const ADD_SYSTEM_POST_FAILURE = "ADD_SYSTEM_POST_FAILURE";
const REMOVE_SYSTEM_POST_FAILURE = "REMOVE_SYSTEM_POST_FAILURE";

const ADD_SYSTEM = "ADD_SYSTEM";
const CLEAR_SYSTEMS = "CLEAR_SYSTEMS";
const REMOVE_SYSTEM = "REMOVE_SYSTEM";

const CLEAR_TERM_FAILURE = "CLEAR_TERM_FAILURE";
const CLEAR_TERM_STARTED = "CLEAR_TERM_STARTED";

const UPDATE_STATED_INCOME = "UPDATE_STATED_INCOME";

const deleteSystems = (contractId) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/reset-systems/`)
      .then(() => {
        return;
      })
      .catch((err) => dispatch(clearTermFailure(err.response.data.ui_message)));
  };
};

const deleteTerm = (contractId) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/reset-term/`)
      .then(() => {
        return;
      })
      .catch((err) => dispatch(clearTermFailure(err.response.data.ui_message)));
  };
};

export function updateStatedIncome(contractId, statedIncome) {
  return (dispatch) => {
    axios
      .post(`/contracts/${contractId}/income/`, {
        contract_id: contractId,
        stated_income: !statedIncome ? 0 : parseFloat(statedIncome) * 100,
      })
      .then(() => dispatch(deleteSystems(contractId)))
      .then(() => dispatch(deleteTerm(contractId)))
      .then(() =>
        dispatch({ type: UPDATE_STATED_INCOME, payload: statedIncome })
      );
  };
}

function clearTerm(contractId, actionType, system, additionalPostData = null) {
  return (dispatch) => {
    dispatch(clearTermStarted());

    axios
      .put(`/contracts/${contractId}/reset-term/`)
      .then(() => {
        if (actionType === "add") {
          dispatch(addSystemPost(system, contractId, additionalPostData));
        } else {
          dispatch(removeSystemPost(system, contractId));
        }
      })
      .catch((err) => dispatch(clearTermFailure(err.response.data.ui_message)));
  };
}

const clearTermFailure = (err) => ({ type: CLEAR_TERM_FAILURE, payload: err });
const clearTermStarted = () => ({ type: CLEAR_TERM_STARTED });

function addSystemPost(system, contractId, additionalPostData = null) {
  const postData = {
    ...additionalPostData,
    pricebook_hvac_system_id: system.id,
  };

  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/add-system/`, postData)
      .then(({ data }) => {
        dispatch(addSystem(data));
        // dispatch(addSystem(system))
      })
      .catch((err) =>
        dispatch(addSystemPostFailure(err.response.data.ui_message))
      );
  };
}

const addSystemPostFailure = (err) => ({
  type: ADD_SYSTEM_POST_FAILURE,
  payload: err,
});

function removeSystemPost(systemId, contractId) {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/remove-system/`, {
        pricebook_hvac_system_id: systemId,
      })
      .then(() => dispatch(removeSystem(systemId)))
      .catch((err) =>
        dispatch(addSystemPostFailure(err.response.data.ui_message))
      );
  };
}

const removeSystemPostFailure = (err) => ({
  type: REMOVE_SYSTEM_POST_FAILURE,
  payload: err,
});

export function addSystem(
  system,
  contractId = null,
  additionalPostData = null
) {
  if (contractId) {
    return clearTerm(contractId, "add", system, additionalPostData);
  }

  return { type: ADD_SYSTEM, payload: system };
}

export function removeSystem(system, contractId = null) {
  if (contractId) {
    return clearTerm(contractId, "remove", system);
  }

  return { type: REMOVE_SYSTEM, payload: system };
}

function systemsReducer(state, action) {
  switch (action.type) {
    case ADD_SYSTEM_POST_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ADD_SYSTEM:
      return {
        ...state,
        loading: false,
        systems: [...state.systems, action.payload],
        term: {
          ...state.term,
          selected: null,
        },
      };
    case CLEAR_TERM_STARTED:
      return {
        ...state,
        // loading: true,
      };
    case CLEAR_TERM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case REMOVE_SYSTEM:
      let systems = [...state.systems];
      let idx = systems.findIndex((s) => s.id === action.payload);

      systems.splice(idx, 1);

      return {
        ...state,
        loading: false,
        systems,
        term: {
          ...state.term,
          selected: null,
        },
      };
    case REMOVE_SYSTEM_POST_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPDATE_STATED_INCOME:
      return {
        ...state,
        statedIncome: action.payload,
        systems: [],
        term: {
          ...state.term,
          selected: null,
        },
      };
    default:
      return state;
  }

  return state;
}

export default systemsReducer;
